import { error } from "../Error";
import http from "../HTTP/HttpService";
import path from "../path";

export async function getApps() {
  const { result, response } = await http.GET(`${path.domain}${path.app.getAccounts}`);

  if (!response.ok) {
    return error("Error getting user's apps", result.error, response.status);
  }

  return mapGetApps(result.body);
}

/**
 * @param {{[key:string]: string}[]} apps
 * @returns {{[key:string]: string}[]}
 */
function mapGetApps(apps) {
  const mappedApps = [];

  apps.sortObject("domain").forEach((app) => {
    // Check if an entry for the domain already exists
    let appIndex = mappedApps.findIndex((result) => result.domain === app.domain);

    if (appIndex < 0) {
      // If not, create a new entry with an empty array
      return mappedApps.push({
        domain: app.domain.toLowerCase(),
        img: app.icon,
        appName: app.appName,
        accounts: [mapApps(app)],
      });
    }

    // Add the accountName to the array for the domain
    mappedApps[appIndex]?.accounts?.push(mapApps(app));
  });

  return mappedApps;
}

function mapApps(app) {
  return {
    id: app.accountId,
    email: app.email ?? null,
    username: app.username ?? null,
    accountName: app.accountName,
    accountType: app.tags[0],
  };
}

export async function addApp(body) {
  const { result, response } = await http.POST(`${path.domain}${path.app.add}`, body);

  if (!response.ok) {
    return error("Error adding app", result.error, response.status);
  }

  return result;
}

export async function getAppPassword(id) {
  const { result, response } = await http.GET(`${path.domain}${path.app.getPassword}/${id}`);

  if (!response.ok) {
    return error("Error adding password", result.error, response.status);
  }

  return result.body;
}

/**
 * @param {string} id
 * @param {{[key: string]: string}} body
 * @returns {Promise<{[key: string]: string}>}
 */
export async function updateApp(id, body) {
  if (!id) {
    return error("Invalid account id provided");
  }

  const { result, response } = await http.PUT(`${path.domain}${path.app.update}/${id}`, body);

  if (!response.ok) {
    return error("Error updating account", result.error, response.status);
  }

  return result.body;
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  addApp,
  getAppPassword,
  getApps,
  updateApp,
};
